import { AppBar, createStyles, IconButton, makeStyles, Toolbar } from '@material-ui/core';
import BackIcon from '@material-ui/icons/ArrowBack';
import React from 'react';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flex: 1,
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
            [theme.breakpoints.down('sm')]: {
                paddingTop: theme.spacing(1.5),
                paddingBottom: theme.spacing(1.5),
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(1),
            }
        },
    })
);

export default function BackPage({ children }) {
    const classes = useStyles();
    const history = useHistory();

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar>
                    <IconButton edge="start" style={{ color: '#fff' }} aria-label="back" onClick={history.goBack}>
                        <BackIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <main className={classes.content}>
                {children}
            </main>
        </div>
    )
}
